module.exports = [
  ...require('./_magicItemRawList_DMG_f'),
  require('./flame_tongue'),
]
